import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { QUAY_ANNOTATION_REPOSITORY } from '../hooks/quay.esm.js';
import { tagRouteRef } from '../routes.esm.js';
import { QuayRepository } from './QuayRepository/QuayRepository.esm.js';
import { QuayTagPage } from './QuayTagPage/component.esm.js';

const isQuayAvailable = (entity) => Boolean(entity?.metadata.annotations?.[QUAY_ANNOTATION_REPOSITORY]);
const Router = () => /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route, { path: "/", element: /* @__PURE__ */ React.createElement(QuayRepository, null) }), /* @__PURE__ */ React.createElement(Route, { path: tagRouteRef.path, element: /* @__PURE__ */ React.createElement(QuayTagPage, null) }));

export { Router, isQuayAvailable };
//# sourceMappingURL=Router.esm.js.map
